import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconToggleDownS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 18 6" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.105789 0.542317C0.352773 0.0578861 0.953431 -0.138468 1.4474 0.103747L9 3.80715L16.5526 0.103747C17.0466 -0.138468 17.6472 0.0578861 17.8942 0.542317C18.1412 1.02675 17.941 1.61581 17.447 1.85803L9 6L0.552992 1.85803C0.0590255 1.61581 -0.141194 1.02675 0.105789 0.542317Z"
        fill="var(--color-typo-primary)"
        fillOpacity="0.3"
      />
    </svg>
  )
}

export const IconToggleDown = createIcon({
  l: IconToggleDownS,
  m: IconToggleDownS,
  s: IconToggleDownS,
  xs: IconToggleDownS,
  name: 'IconToggleDown',
})
